import moment from 'moment'

const state = {
  v_locale: localStorage.getItem('userLocale') || (navigator.language || navigator.userLanguage).toLowerCase(),
  name: 'CTF',
  ctfMode: 'teams',
  profile: {
    name: '',
    email: '',
    token: ''
  },
  startTime: moment(),
  endTime: moment().add(48, 'hours'),
  now: moment(),
  timeDelta: 0,
  router: null
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js